import { VALID_AREA_CODE, NOT_VALID_AREA_CODE } from './actionTypes'

export const validAreaCode = () => {
    return {
        type: VALID_AREA_CODE,
    }
}

export const notValidAreaCode = () => {
    return {
        type: NOT_VALID_AREA_CODE,
    }
}
